// Page-scoped values supplied once per page by the loader snippet.
    var smartPageCfg = window.smartPageConfig || {};

  
    

    if (window.jQuery){

    } else {

        var headTag = document.getElementsByTagName("head")[0];
        var newScript = document.createElement("script");
        newScript.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.3/jquery.min.js";
        headTag.appendChild(newScript);

    }


    var existingScript = document.getElementById('smartbPopper');
  	if (!existingScript) {

		var countrysmartb = 'smartbadgecountry';
        var smartbcountryName = '';

        setTimeout(function(){ 
            checksmartbjquery();
        }, 1000);

  	}

    function getCountryCodesb() {
        
        if(thaliacustomercountry == ''){ 
        thaliaCustomerCookie();
        thaliacustomercountry = thaliaGetCookie("thaliacustomercountry");
        getCountryNamesb(thaliacustomercountry);
        }else{
        getCountryNamesb(thaliacustomercountry);
        }

    }

        function getCountryNamesb(countryCode) {
         var country_data = "AF,Afghanistan|AL,Albania|DZ,Algeria|AD,Andorra|AO,Angola|AI,Anguilla|AQ,Antarctica|AG,Antigua and Barbuda|AR,Argentina|AM,Armenia|AW,Aruba|AU,Australia|AT,Austria|AZ,Azerbaijan|BS,Bahamas|BH,Bahrain|BD,Bangladesh|BB,Barbados|BY,Belarus|BE,Belgium|BZ,Belize|BJ,Benin|BM,Bermuda|BT,Bhutan|BO,Bolivia|BQ,Bonaire,Sint Eustatius and Saba|BA,Bosnia and Herzegovina|BW,Botswana|BV,Bouvet Island|BR,Brazil|IO,British Indian Ocean Territory|BN,Brunei Darussalam|BG,Bulgaria|BF,Burkina Faso|BI,Burundi|CV,Cabo Verde|KH,Cambodia|CM,Cameroon|CA,Canada|KY,Cayman Islands|CF,Central African Republic|TD,Chad|CL,Chile|CN,China|CX,Christmas Island|CC,Cocos (Keeling) Islands|CO,Colombia|KM,Comoros|CG,Congo|CD,Congo,Democratic Republic of the|CK,Cook Islands|CR,Costa Rica|CI,Côte d'Ivoire|HR,Croatia|CU,Cuba|CW,Curaçao|CY,Cyprus|CZ,Czech Republic|DK,Denmark|DJ,Djibouti|DM,Dominica|DO,Dominican Republic|EC,Ecuador|EG,Egypt|SV,El Salvador|GQ,Equatorial Guinea|ER,Eritrea|EE,Estonia|SZ,Eswatini|ET,Ethiopia|FK,Falkland Islands (Malvinas)|FO,Faroe Islands|FJ,Fiji|FI,Finland|FR,France|GF,French Guiana|PF,French Polynesia|TF,French Southern Territories|GA,Gabon|GM,Gambia|GE,Georgia|DE,Germany|GH,Ghana|GI,Gibraltar|GR,Greece|GL,Greenland|GD,Grenada|GP,Guadeloupe|GU,Guam|GT,Guatemala|GG,Guernsey|GN,Guinea|GW,Guinea-Bissau|GY,Guyana|HT,Haiti|HM,Heard Island and McDonald Islands|VA,Holy See|HN,Honduras|HK,Hong Kong|HU,Hungary|IS,Iceland|IN,India|ID,Indonesia|IR,Iran|IQ,Iraq|IE,Ireland|IM,Isle of Man|IL,Israel|IT,Italy|JM,Jamaica|JP,Japan|JE,Jersey|JO,Jordan|KZ,Kazakhstan|KE,Kenya|KI,Kiribati|KP,Korea|KR,Korea|KW,Kuwait|KG,Kyrgyzstan|LA,Lao People's Democratic Republic|LV,Latvia|LB,Lebanon|LS,Lesotho|LR,Liberia|LY,Libya|LI,Liechtenstein|LT,Lithuania|LU,Luxembourg|MO,Macao|MG,Madagascar|MW,Malawi|MY,Malaysia|MV,Maldives|ML,Mali|MT,Malta|MH,Marshall Islands|MQ,Martinique|MR,Mauritania|MU,Mauritius|YT,Mayotte|MX,Mexico|FM,Micronesia|MD,Moldova|MC,Monaco|MN,Mongolia|ME,Montenegro|MS,Montserrat|MA,Morocco|MZ,Mozambique|MM,Myanmar|NA,Namibia|NR,Nauru|NP,Nepal|NL,Netherlands|NC,New Caledonia|NZ,New Zealand|NI,Nicaragua|NE,Niger|NG,Nigeria|NU,Niue|NF,Norfolk Island|MK,North Macedonia|MP, Northern Mariana Islands|NO,Norway|OM,Oman|PK,Pakistan|PW,Palau|PS,Palestine|PA,Panama|PG,Papua New Guinea|PY,Paraguay|PE,Peru|PH,Philippines|PN,Pitcairn|PL,Poland|PT,Portugal|PR,Puerto Rico|QA,Qatar|RE,Réunion|RO,Romania|RU,Russian Federation|RW,Rwanda|BL,Saint Barthélemy|SH,Saint Helena|KN,Saint Kitts and Nevis|LC,Saint Lucia|MF,Saint Martin (French part)|PM,Saint Pierre and Miquelon|VC,Saint Vincent and the Grenadines|WS,Samoa|SM,San Marino|ST,Sao Tome and Principe|SA,Saudi Arabia|SN,Senegal|RS,Serbia|SC,Seychelles|SL,Sierra Leone|SG,Singapore|SX,Sint Maarten (Dutch part)|SK,Slovakia|SI,Slovenia|SB,Solomon Islands|SO,Somalia|ZA,South Africa|GS,South Georgia and the South Sandwich Islands|SS,South Sudan|ES,Spain|LK,Sri Lanka|SD,Sudan|SR,Suriname|SJ,Svalbard and Jan Mayen|SE,Sweden|CH,Switzerland|SY,Syrian Arab Republic|TW,Taiwan|TJ,Tajikistan|TZ,Tanzania|TH,Thailand|TL,Timor-Leste|TG,Togo|TK,Tokelau|TO,Tonga|TT,Trinidad and Tobago|TN,Tunisia|TR,Turkey|TM,Turkmenistan|TC,Turks and Caicos Islands|TV,Tuvalu|UG,Uganda|UA,Ukraine|AE,United Arab Emirates|GB,United Kingdom|US,United States|UM,United States Minor Outlying Islands|UY,Uruguay|UZ,Uzbekistan|VU,Vanuatu|VE,Venezuela|VN,Viet Nam|VG,Virgin Islands|VI,Virgin Islands|WF,Wallis and Futuna|EH,Western Sahara|YE,Yemen|ZM,Zambia|ZW,Zimbabwe";
            var countries = country_data.split("|");
            for (var i = 0; i < countries.length; i++) {
            var country = countries[i].split(",");
            var countryCodedata = country[0];
            var Visitorcountry = country[1];
            if(countryCode== countryCodedata)
            {
               var VisitorCountryName=Visitorcountry;
            }
            }
            var visitorclass = document.getElementsByClassName('smartbVisitorCountry');
                for (var i = 0; i < visitorclass.length; i++) {
                var issetvisitorcountryrule = visitorclass[i].getAttribute('visitorcountryrule');  
                var secondChild = visitorclass[i].querySelector('div:nth-child(1)');
                var thirdChild = secondChild.querySelector('div:nth-child(1)'); 
                if( issetvisitorcountryrule == '1'){
                // $('.primebVisitorCountryName').replaceWith(VisitorCountryName);
                // visitorclass[i].style.display= 'block';
                var elements = document.querySelectorAll('.smartbVisitorCountryName');
                elements.forEach(function(element) {
                element.textContent = VisitorCountryName;
                });
                }
                }
        }


    function checksmartbjquery() {
        if (window.jQuery) {
            checkSmartVariantInventory(smartPageCfg.firstVariantTitle,"first");
            
            $(document).on("change", ".single-option-selector", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".single-option-selector").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("change", ".ProductForm__Option select", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".ProductForm__Option select").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("click", ".tt-options-swatch li", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".tt-options-swatch li").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("click", ".swatch-element", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".swatch-element").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("change", ".form__input--select", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".form__input--select").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("change", ".sgl-opt-selector-product-template", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".sgl-opt-selector-product-template").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("click", ".tt-options-swatch li", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".tt-options-swatch li").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("change", ".product-option-value-item", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".product-option-value-item").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("click", ".clickyboxes a", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".clickyboxes a").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("change", "[data-product-options-container] .form-field-input", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $("[data-product-options-container] .form-field-input").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("change", "#data-product-option-0", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $("#data-product-option-0").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("click", ".product-options__section .active", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".product-options__section .active").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("click", ".product-options__value", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".product-options__value").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("click", ".variant-input", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".variant-input").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("change", ".product-form__single-selector", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".product-form__single-selector").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("click", ".gt_swatches--select.gf_active", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".gt_swatches--select.gf_active").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("click", ".nt-swatch", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".nt-swatch").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("change", ".disclosure--input", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".disclosure--input").each(function(key) {
                        optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("click", ".product-form__input input", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                $(".product-form__input input[type=radio]:checked").each(function(key) {
                    optionMap[key] = $(this).val();
                });
                checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("click", ".swatch-container input", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".swatch-container input[type=radio]:checked").each(function(key) {
                    optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

            $(document).on("click", ".swatch--gl input", function() {
                var optionMap = [];
                if(optionMap.length == 0){
                    $(".swatch--gl input[type=radio]:checked").each(function(key) {
                    optionMap[key] = $(this).val();
                    });
                    checkSmartVariantInventory(optionMap);
                }
            });

        }else{
            setTimeout(function() { checksmartbjquery() }, 2000);
        }
    }

    window.addEventListener('load', (event) => {
        smartbCountdownTimer();
        resizeFunction();
        
            getCountryCodesb();
        
        
        document.getElementById("smart-modal-close").onclick = function() {mymodalsmartb()};
        window.onclick = function(event) {
            if (event.target.classList[1] == 'smart-modal-open') {
                mymodalsmartb();
            }
        }
    });

    // Function to be invoked when the element becomes visible
        function handleVisibleElement(entries, observer) {
        entries.forEach((entry) => {
        if (entry.isIntersecting) {
        // Element is visible, perform desired actions here
        // Call your function here
        smartbCountdownTimer();
       
            getCountryCodesb();
       
        // Stop observing the target element
        observer.unobserve(entry.target);
        }
        });
        }

        // Target element with the class 'product-recommendations'
        const targetElement = document.querySelector('.product-recommendations');      

        if(targetElement)
            {
            // Create a new Intersection Observer instance
            const observer = new IntersectionObserver(
            (entries) => {
            // Use a debounce function to limit the number of function invocations
            debounce(handleVisibleElement, 100)(entries, observer);
            },
            {
            root: null, // Viewport
            threshold: 0.5, // 50% of the element must be visible to trigger the callback
            }
            );
        observer.observe(targetElement);
        }

        // Debounce function to limit the rate of function invocations
        function debounce(func, delay) {
        let timeoutId;
        return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
        func.apply(this, args);
        }, delay);
        };
        }


    function smartbCountdownTimer() {

        screensizesmartFunction();
        resizeFunction();
        
        var smartbText2 = document.getElementsByClassName('smartbText');
        if(smartbText2[0]){
            for (var i = 0; i < smartbText2.length; i++) {
                var value = smartbText2[i].innerHTML;
                if( value.indexOf("[[today") != -1  ){
                    expdeliverydatesmart(value,i);
                }
            }
            
        }

        var smartbText = document.getElementsByClassName('smartbText');
        if(smartbText[0]){
            for (var i = 0; i < smartbText.length; i++) {
                var value = smartbText[i].innerHTML;
                if( value.indexOf("CountdownTimer:") != -1  ){
                    var metaval= smartbText[i].getAttribute('data-timerval');
                    myTimer2(value,i,metaval);
                }
            }
            
        } 

        var smartbsku = smartPageCfg.productSku;
        var skuclass = document.getElementsByClassName('smartbsku');
        if(smartbsku == 0){
            for (var i = 0; i < skuclass.length; i++) {
                if(skuclass[i].dataset.sku == 0){
                    var parentsku = skuclass[i].parentElement;
                    var parent2sku = parentsku.parentElement;
                    parent2sku.style.cssText = 'display:none !important';
                }
            }
        }

        setTimeout(function(){ 
            var smartinstances2 = tippy('[data-tippy-content]');
        }, 1000);

        if(countrysmartb == 'smartbadgecountry'){
            countrysmartb = 'newsmartbadgecountry';
            var countrycount = document.getElementsByClassName('smartbCountry');
            if (thaliacustomercountry == '') {
            thaliaCustomerCookie();
            thaliacustomercountry = thaliaGetCookie("thaliacustomercountry");
            var mycountrysmartb = thaliacustomercountry;
            } else {
            var mycountrysmartb = thaliacustomercountry;
            }
            if (countrycount.length > 0) {
                
                        var countryclassSmartb = document.getElementsByClassName('smartbCountry');
                
                        for (var i = 0; i < countryclassSmartb.length; i++) {
                            var counrtylistb = countryclassSmartb[i].getAttribute('data-countryselected');
                            var position = counrtylistb.search(mycountrysmartb);
                            smartbcountryName = mycountrysmartb;
                            if(position < 0){ 
                                countryclassSmartb[i].style.cssText = 'display:none !important';
                                
                            }else{
                                countryclassSmartb[i].style.display= 'block';
                                countryclassSmartb[i].setAttribute('countryrule', '1');

                                if (countryclassSmartb[i].classList.contains('smartbScreenSize')) {
                                    var screenlist = countryclassSmartb[i].getAttribute('data-screensizeselected');
                                    var screensizeArray = screenlist.split(",");
                                    var smdevice = window.matchMedia( "screen and (max-width: 767.98px)" );
                                    var mddevice = window.matchMedia( "screen and (min-width: 768px) and (max-width: 991.98px)" );
                                    var lgdevice = window.matchMedia( "screen and (min-width: 992px) and (max-width: 1199.98px)" );
                                    var xldevice = window.matchMedia( "(min-width: 1200px)" );

                                    if (smdevice.matches ){
                                        if(screensizeArray[0] == '1'){
                                        }else{
                                            countryclassSmartb[i].style.setProperty("display", "none", "important");
                                        }
                                    }else if( mddevice.matches){
                                        if(screensizeArray[1] == '1'){
                                        }else{
                                            countryclassSmartb[i].style.setProperty("display", "none", "important");
                                        }
                                    }else if(lgdevice.matches){
                                        if(screensizeArray[2] == '1'){
                                        }else{
                                            countryclassSmartb[i].style.setProperty("display", "none", "important");
                                        }
                                    }else{
                                        if(screensizeArray[3] == '1'){
                                        }else{
                                            countryclassSmartb[i].style.setProperty("display", "none", "important");
                                        }
                                    }

                                }

                            }
                        }
                    }
                };
                
            
        

        var mypage = smartPageCfg.template;
        var myproductid = smartPageCfg.productId;
        for (var i = 0; i < 6; i++) {
            setTimeout(function(){ 
                smartsetlivevisit(mypage,myproductid);
            }, 500); 
        }
        

    }

    function expdeliverydatesmart(value,count) {
        var weekdays = '';
        var dateformatselected = '';
        var datelang = 'en';
        var smartbTextdate = document.getElementsByClassName('smartbText');
        var realvalue = value;
        var pos = realvalue.indexOf("[[today");
        var pos2 = realvalue.indexOf("]]");
        var startres = realvalue.slice(pos+8, pos2);
        realvalue = realvalue.replace("[[today,", "" );
        realvalue = realvalue.replace("]]", "" );
        var pos3 = realvalue.indexOf("[[today");
        var pos4 = realvalue.indexOf("]]");
        var endres = realvalue.slice(pos3+8, pos4);
        realvalue = realvalue.replace("[[today,", "" );
        realvalue = realvalue.replace("]]", "" );
        var getlang = startres.split(",");
        var wrongdays = weekdays.split(",");
        var startDate = new Date(new Date().getTime()+(parseInt(startres)*24*60*60*1000));
        var today = new Date(new Date().getTime());
        var firstinc=0;
        while (today <= startDate) {
            var getday = String(today.getDay());
            if(wrongdays.indexOf(getday) != -1){
            startDate.setDate(startDate.getDate() + 1);
            firstinc++;
            }
            today.setDate(today.getDate() + 1);
        }
        var setlang = 'en';
        if(getlang.length > 1){
            setlang = getlang[1];
        }
        moment.locale(setlang);
        value = value.replace("[[today,"+startres+"]]", moment(startDate).locale(setlang).format(dateformatselected));

        var extradays = firstinc+parseInt(endres);
        var endDate = new Date(new Date().getTime()+(extradays*24*60*60*1000));
        var todayend = startDate;
        var secinc=0;
        while (todayend <= endDate) {
            var getday = String(todayend.getDay());
            if(wrongdays.indexOf(getday) != -1){
            endDate.setDate(endDate.getDate() + 1);
            secinc++;
            }
            todayend.setDate(todayend.getDate() + 1);
        }
        value = value.replace("[[today,"+endres+"]]", moment(endDate).locale(setlang).format(dateformatselected));
        smartbTextdate[count].innerHTML = value;
        var getchild = smartbTextdate[count].getElementsByClassName('smart-counter');
        if(getchild[0]){
            getchild[0].classList.remove("smart-counter");
        }
    }

    function checkSmartVariantInventory(optionMap,myfirstone='') {
        var productname = smartPageCfg.productHandle;  
        var variantproductid = smartPageCfg.productId;   
        var mydomclass = document.getElementsByClassName('smartbVariantInventory');   
        if(mydomclass.length > 0){
            if(optionMap.length > 0){  
                var realval = '';
                if(myfirstone == "first"){
                    realval = optionMap;
                }else{
                    for(var i = 0; i < optionMap.length; i++){
                        var spaces = ' / ';
                        if(i == 0){
                            spaces = '';
                        }
                        realval += spaces+optionMap[i];
                    }
                }
                
                var smartBadgesAll = document.getElementsByClassName('smartBadges');
                for (var i = 0; i < smartBadgesAll.length; i++) {
                    var smartbOuterClass = smartBadgesAll[i].getAttribute('data-smartbOuterClass');
                    var smartbOuterStyle = smartBadgesAll[i].getAttribute('data-smartbOuterStyle');
                    var smartbInnerClass = smartBadgesAll[i].getAttribute('data-smartbInnerClass');
                    var smartbInnerStyle = smartBadgesAll[i].getAttribute('data-smartbInnerStyle');
                    var smartbGroup = smartBadgesAll[i].getAttribute('data-smartbGroup');
                    var smartbProductId = smartBadgesAll[i].getAttribute('data-smartproductsid');
                    var smartbMaxDisplayBadge=parseInt(smartBadgesAll[i].getAttribute('data-smartbMaxDisplayBadge'));
                    if(smartbProductId == variantproductid){
                        hitsmartbpage(productname,variantproductid,smartbOuterClass,smartbOuterStyle,smartbInnerClass,smartbInnerStyle,smartbGroup,smartbMaxDisplayBadge,realval)
                    }
                }
            }
        }
       
            setTimeout(function(){ 
            getCountryCodesb();
            },500);
        
    }


    function hitsmartbpage(productname,variantproductid,smartbOuterClass,smartbOuterStyle,smartbInnerClass,smartbInnerStyle,smartbGroup,smartbMaxDisplayBadge,realval) {
        
        var result = Math.random().toString(36).substring(2,7);
        if(smartbGroup == 1){
			var urlhit = productname+'/?view=smartbvariant&sort_by='+result+'&outerclass=='+smartbOuterClass+'&outerstyle=='+smartbOuterStyle+'&innerclass=='+smartbInnerClass+'&innerstyle=='+smartbInnerStyle+'&group==1&smartbMaxDisplayBadge=='+smartbMaxDisplayBadge+'&page=='+realval;
        }else if(smartbGroup == 2){
			var urlhit = productname+'/?view=smartbvarianttwo&sort_by='+result+'&outerclass=='+smartbOuterClass+'&outerstyle=='+smartbOuterStyle+'&innerclass=='+smartbInnerClass+'&innerstyle=='+smartbInnerStyle+'&group==2&smartbMaxDisplayBadge=='+smartbMaxDisplayBadge+'&page=='+realval;
        }else{
            var urlhit = productname+'/?view=smartbvariantthree&sort_by='+result+'&outerclass=='+smartbOuterClass+'&outerstyle=='+smartbOuterStyle+'&innerclass=='+smartbInnerClass+'&innerstyle=='+smartbInnerStyle+'&group==3&smartbMaxDisplayBadge=='+smartbMaxDisplayBadge+'&page=='+realval;
        }
        var xhr = new XMLHttpRequest();
        xhr.open("GET", urlhit, true);
        xhr.onreadystatechange  = function() {
            if (this.readyState === XMLHttpRequest.DONE) {
                if (this.status === 200) {
                    if(this.responseText == 0){
                        $('.outersmartb'+variantproductid+'-'+smartbGroup+' .smartbText .smartbVariantInventory').html("0");
                        $('.outersmartb'+variantproductid+'-'+smartbGroup+' .smart-counter').removeClass("smart-counter");
                        $('.outersmartb'+variantproductid+'-'+smartbGroup+' .hidevariant').remove();
                    }else{
                        $('.outersmartb'+variantproductid+'-'+smartbGroup).replaceWith( this.responseText );
                        $('.outersmartb'+variantproductid+'-'+smartbGroup+' .smart-counter').removeClass("smart-counter");
                        var countryclass = document.getElementsByClassName('smartbCountry');
                        for (var i = 0; i < countryclass.length; i++) {
                            var counrtylist = countryclass[i].getAttribute('data-countryselected');
                            var position = counrtylist.search(smartbcountryName);
                            if(position < 0){ 
                                countryclass[i].style.cssText = 'display:none !important';
                            }else{
                                countryclass[i].style.display= 'block';
                            }
                        }
                        setTimeout(function(){ 
                            smartbCountdownTimer();
                        }, 500); 
                    }
                } else {
                    console.log('failed variant req');
                }
            }
        };
        xhr.send();

    }

    function smartsetlivevisit(mypage,myproductid) {
        setTimeout(function(){ 

            var settimelive = '';
            var setvisitlimit = '';

            var d = new Date();
            var time = setcookietimestampsmart(settimelive);
            var mytime = '';
            if(settimelive < 5){
                mytime = (time * 60 );
            }else if(settimelive > 4 && settimelive < 8){
                mytime =(time * 60 * 60 );
            }else if(settimelive > 7){
                mytime = (time * 24 * 60 * 60 );
            }

            var smartloop2 = document.getElementsByClassName('smartbloop');
            for (var i = 0; i < smartloop2.length; i++) {
                var smallloop2 = smartloop2[i].parentElement;
                var parentloop2 = smallloop2.getAttribute('data-smartproductid');
                var myuser = getCookiesmart("smartvisits"+parentloop2);
                if (myuser != "") {
                    myhttpreqsmart(parentloop2,0,mytime,setvisitlimit);
                } else {
                    myhttpreqsmart(parentloop2,1,mytime,setvisitlimit);
                    setCookiesmart("smartvisits"+parentloop2, 'setsmartvisits', settimelive);
                }

            }

            var smartloop = document.getElementsByClassName('smartbloop');
            for (var i = 0; i < smartloop.length; i++) {
                if(mypage == 'product'){
                    var smallloop = smartloop[i].parentElement;
                    var parentloop = smallloop.getAttribute('data-smartproductid');
                    if(parentloop == myproductid){
                        smartloop[i].classList.add("smartvisitsb"+parentloop);
                    }else{
                        var removeloop = smartloop[i].parentElement;
                        var removeloop2 = removeloop.parentElement;
                        var removeloop3 = removeloop2.parentElement;
                        removeloop3.style.visibility = 'hidden';
                        smartloop[i].classList.remove("smartbloop");
                    }
                }else{
                  var oldloop = smartloop[i].parentElement;
                  var newloop = oldloop.parentElement;
                  var newloop2 = newloop.parentElement;
                  newloop2.style.visibility = 'hidden';
                  smartloop[i].classList.remove("smartbloop");
                  newloop2.remove();
                }
            }

        }, 1000);
    }

    function myhttpreqsmart(lastid,mynew,gettime,setvisitlimit) {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
                var pageliveview = JSON.parse(this.responseText);
                var smartvisits = document.getElementsByClassName("smartvisitsb"+lastid);
                for (var i = 0; i < smartvisits.length; i++) {
                    if(setvisitlimit < pageliveview.pageviews){
                        smartvisits[i].innerHTML = pageliveview.pageviews;
                        var removeloop = smartvisits[i].parentElement;
                        var removeloop2 = removeloop.parentElement;
                        var removeloop3 = removeloop2.parentElement;
                        removeloop3.style.visibility = 'visible';
                    }else{
                        var removeloop = smartvisits[i].parentElement;
                        var removeloop2 = removeloop.parentElement;
                        var removeloop3 = removeloop2.parentElement;
                        removeloop3.style.visibility = 'hidden';
                        smartvisits[i].classList.remove("smartbloop");
                    }
                        
                }
            }
        };
        xhttp.open("GET","https://&lt;production-host&gt;/?shopifyid="+lastid+"&new="+mynew+"&time="+gettime, true);
        xhttp.send();
    }

    

    function mymodalsmartb() {
      var target = document.getElementById("smart-modal-window");
      var parenttarget = target.parentElement;
      if (parenttarget.classList.contains('smart-modal-open')) {
        parenttarget.classList.remove('smart-modal-open');
        document.getElementById('smart-modal-content').innerHTML = '';
      }
    }

    window.addEventListener('resize', resizeFunction);

    window.addEventListener('resize', screensizesmartFunction);

    function resizeFunction() { 
        var fontadjust = document.getElementsByClassName('smart-font-adjust');
        var heightadjust = document.getElementsByClassName('smart-height-adjust');

        var xsdevice = window.matchMedia( "(max-width: 575.98px)" );
        var smdevice = window.matchMedia( "(max-width: 767.98px)" );
        var mddevice = window.matchMedia( "(max-width: 991.98px)" );
        var lgdevice = window.matchMedia( "(max-width: 1199.98px)" );
        var xldevice = window.matchMedia( "(min-width: 1200px)" );

        for (var i = 0; i < fontadjust.length; i++) {
            var mobilesize = '';
            var tabletsize = '';
            mobilesize = fontadjust[i].getAttribute('data-mobilesize');
            tabletsize = fontadjust[i].getAttribute('data-tabletsize');

            fontadjust[i].style.fontSize = 'inherit';

            if (xsdevice.matches || smdevice.matches ){
                if(mobilesize > 0){
                    fontadjust[i].style.fontSize = mobilesize+'px';

                }
            }else if(mddevice.matches){
                if(tabletsize > 0){
                    fontadjust[i].style.fontSize = tabletsize+'px';

                }
            }
        }
        var heightadjust = document.getElementsByClassName('smart-height-adjust');
        for (var i = 0; i < heightadjust.length; i++) {
            var image = heightadjust[i].getElementsByClassName("smartbImage");
            var mobileheight = '';
            var tabletheight = '';

            var defaultHeight = heightadjust[i].getAttribute('data-defaultheight');
            mobileheight = heightadjust[i].getAttribute('data-mobileheight');
            tabletheight = heightadjust[i].getAttribute('data-tabletheight');

            var imgsrcsvg = image[0].getAttribute("src");
            var present = imgsrcsvg.search("svg");
            if(present > 0){
                image[0].style.height = defaultHeight+'px';
                image[0].style.maxHeight = defaultHeight+'px';
                image[0].style.display = "block";
                if (xsdevice.matches || smdevice.matches ){
                    if(mobileheight > 0){
                        image[0].style.height = mobileheight+'px';
                        image[0].style.maxHeight = mobileheight+'px';
                        image[0].style.display = "block";
                    }
                }else if(mddevice.matches){
                    if(tabletheight > 0){
                        image[0].style.height = tabletheight+'px';
                        image[0].style.maxHeight = tabletheight+'px';
                        image[0].style.display = "block";
                    }
                }

            }else{
                image[0].style.maxHeight = defaultHeight+'px';
                image[0].style.display = "block";
                if (xsdevice.matches || smdevice.matches ){
                    if(mobileheight > 0){
                        image[0].style.maxHeight = mobileheight+'px';
                        image[0].style.display = "block";
                    }
                }else if(mddevice.matches){
                    if(tabletheight > 0){
                        image[0].style.maxHeight = tabletheight+'px';
                        image[0].style.display = "block";
                        
                    }
                }
            }
        }

    } 

    function screensizesmartFunction() { 
        var screensizeclass = document.getElementsByClassName('smartbScreenSize');
        for (var i = 0; i < screensizeclass.length; i++) {

            var issetcountryrule = screensizeclass[i].getAttribute('countryrule');

            if( issetcountryrule == '1'){
            
                var screenlist = screensizeclass[i].getAttribute('data-screensizeselected');
                var screensizeArray = screenlist.split(",");
                
                var smdevice = window.matchMedia( "screen and (max-width: 767.98px)" );
                var mddevice = window.matchMedia( "screen and (min-width: 768px) and (max-width: 991.98px)" );
                var lgdevice = window.matchMedia( "screen and (min-width: 992px) and (max-width: 1199.98px)" );
                var xldevice = window.matchMedia( "(min-width: 1200px)" );

                if (smdevice.matches ){
                    if(screensizeArray[0] == '1'){
                        screensizeclass[i].style.display= 'block';
                    }else{
                        screensizeclass[i].style.setProperty("display", "none", "important");
                    }
                }else if( mddevice.matches){
                    if(screensizeArray[1] == '1'){
                        screensizeclass[i].style.display= 'block';
                    }else{
                        screensizeclass[i].style.setProperty("display", "none", "important");
                    }
                }else if(lgdevice.matches){
                    if(screensizeArray[2] == '1'){
                        screensizeclass[i].style.display= 'block';
                    }else{
                        screensizeclass[i].style.setProperty("display", "none", "important");
                    }
                }else{
                    if(screensizeArray[3] == '1'){
                        screensizeclass[i].style.display= 'block';
                    }else{
                        screensizeclass[i].style.setProperty("display", "none", "important");
                    }
                }

            }
        }

    }

    function smartredirectLink(badgeval,links,smartbannerid,modalsize) {

        if(badgeval != ''){

            var badgelink = badgeval;
            if(links == 0){
                window.location.href = badgelink;
            }else{
                window.open(badgelink,'_blank');
            }

        }

        if(links == 2){
            var target = document.getElementById("smart-modal-outer");
            var myclasses = '';
            if(modalsize == 0){
                myclasses = 'smart-modal-window smart-modal-small';
            }else if(modalsize == 2){
                myclasses = 'smart-modal-window smart-modal-large';
            }else{
                myclasses = 'smart-modal-window';
            }
            
            document.getElementById('smart-modal-outer').classList.add('smart-modal-open');
            var setclass = document.getElementById('smart-modal-window');
            setclass.className = '';
            setclass.className = myclasses;
            var xhr = new XMLHttpRequest();
            var url = '/?view=smartmeta&id==badge-popup-'+smartbannerid;
            xhr.open("GET", url, true);
            xhr.setRequestHeader("Cache-Control", "max-age=3600");
            xhr.onreadystatechange = function() {
                // if (this.readyState === XMLHttpRequest.DONE) {
                    if (this.status === 200) {
                        document.getElementById('smart-modal-content').innerHTML = this.responseText;
                    } else {
                        console.log(this.status, this.statusText);
                    }
                // }
                };
                xhr.send();
        }
    
    }

    function toValidDate2(datestring){
        return datestring.replace(/(\d{2})(\/)(\d{2})/, "$3$2$1");   
    }

    function myTimer2(newvalue,count,metaval) {

        var smartbText2 = document.getElementsByClassName('smartbText');
        var againvalue = newvalue;
        var pos3 = newvalue.indexOf("[[ CountdownTimer:");
        var pos4 = newvalue.indexOf("M,");
        if(pos4 < 0){
            pos4 = newvalue.indexOf(" ]]");
            var res = newvalue.slice(pos3+18, pos4);
        }else{

            if(metaval)
            {          
            var res = metaval;
            }else{
            var res = newvalue.slice(pos3 + 18, pos4 + 1);
            }
            
        }
        var pos5 = newvalue.indexOf(" ]]");
        var pos6 = newvalue.indexOf("|");
        var endres = againvalue.slice(pos3+18, pos5);
        if(pos6 < 0){
            var customtext = '';
        }else{
            var customtext = againvalue.slice(pos6+1, pos5);
        }
        newvalue = newvalue.replace("[[ CountdownTimer:", "" );
        newvalue = newvalue.replace(" ]]", "" );
        endres = endres.replace(" |"+customtext , "" );
        var getlang = endres.split(",");
        var setlang2 = 'en';
        if(getlang.length > 1){
            if(getlang[1] == 'custom'){
                if (getlang[2] == null){
                    var setdays = '';
                }else{
                    var setdays = getlang[2];
                }
                if (getlang[3] == null){
                    var sethours = '';
                }else{
                    var sethours = getlang[3];
                }
                if (getlang[4] == null){
                    var setminutes = '';
                }else{
                    var setminutes = getlang[4];
                }
                if (getlang[5] == null){
                    var setseconds = '';
                }else{
                    var setseconds = getlang[5];
                }
            }else{
            setlang2 = getlang[1];
            var setmoment = moment();
            setmoment.locale(setlang2);
            setmoment.subtract({hours: 0, minutes: 0, seconds: 35});
            var getseconds = setmoment.toNow(true);
            setmoment.subtract({hours: 0, minutes: 10, seconds: 59});
            var getminutes = setmoment.toNow(true);
            setmoment.subtract({hours: 5, minutes: 59, seconds: 59});
            var gethours = setmoment.toNow(true);
            setmoment.subtract({hours: 222, minutes: 59, seconds: 59});
            var getdays = setmoment.toNow(true);
            var setseconds = getseconds.split(" ").pop();
            var setminutes = getminutes.split(" ").pop();
            var sethours = gethours.split(" ").pop();
            var setdays = getdays.split(" ").pop();
            }
        }else{
            var setdays = "days";
            var sethours = "hours";
            var setminutes = "minutes";
            var setseconds = "seconds";
        }

        var x = setInterval(function() { 
            let end = new Date(toValidDate2(res));
            let start = new Date();
            var remaintime = end - start;
            var days = Math.floor(remaintime / (1000 * 60 * 60 * 24));
            var hours = Math.floor((remaintime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((remaintime % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((remaintime % (1000 * 60)) / 1000);
            var realtimeleft = days +" "+ setdays +" "+ hours +" " + sethours +" "+ minutes +" "+ setminutes +" "+ seconds +" " + setseconds + " ";
            if(seconds < 0 && customtext == ''){
                realtimeleft = "0 "+setdays+" 0 "+sethours+" 0 "+setminutes+" 0 "+setseconds;
            }else if(seconds < 0 && customtext != ''){
                newvalue = customtext;
            }else{
                newvalue = newvalue.replace(" |"+customtext , "");
            }
            if(getlang[1] == 'custom'){
                realtimeleft='';
                if(setdays != ''){
                realtimeleft = days +""+ setdays+ " ";
                }
                if(sethours != ''){
                realtimeleft = realtimeleft + hours +"" + sethours +" ";
                }
                if(setminutes != ''){
                realtimeleft = realtimeleft + minutes +""+ setminutes +" ";
                }
                if(setseconds != ''){
                realtimeleft = realtimeleft + seconds +"" + setseconds + " ";
                }
            }
            smartbText2[count].innerHTML = newvalue.replace(endres,realtimeleft);
            smartbText2[count].classList.remove("smart-counter");
            if (remaintime < 0) { 
                clearInterval(x); 
            } 
        }, 1000); 

    }

    function setCookiesmart(cname, cvalue, exdays) {
      var d = new Date();
      var time = setcookietimestampsmart(exdays);
      if(exdays < 5){
        d.setTime(d.getTime() + (time * 60 * 1000));
      }else if(exdays > 4 && exdays < 8){
        d.setTime(d.getTime() + (time * 60 * 60 * 1000));
      }else if(exdays > 7){
        d.setTime(d.getTime() + (time * 24 * 60 * 60 * 1000));
      }
      
      var expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookiesmart(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    function setcookietimestampsmart(time) {
        var realtime='';
        if(time==1){
            realtime=1;
        }else if(time==2){
            realtime=5;
        }else if(time==3){
            realtime=10;
        }else if(time==4){
            realtime=30;
        }else if(time==5){
            realtime=1;
        }else if(time==6){
            realtime=6;
        }else if(time==7){
            realtime=12;
        }else if(time==8){
            realtime=1;
        }else if(time==9){
            realtime=7;
        }else if(time==10){
            realtime=15;
        }else if(time==11){
            realtime=30;
        }
        return realtime;
    }

